// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../../account/views/RedirectoLogin";
import { AppHeader } from "imagus-components";
import DocumentGenerate from "../containers/DocumentGenerate";

class ApiDocument extends Component<*> {

  render(): * {
    return (
      <UserAuth principal='user' unAuthChildren={<RedirectoLogin />} >
        <div className="app-main">
          <AppHeader
            title="API Documentation"
            IconName="Book"
          />
          <div className="app-panel">
            <div className="app-panel-content">
              <DocumentGenerate endpoint="/api/v2/documentation" />
            </div>
          </div>
        </div>
      </UserAuth>
    );
  }
}

export default ApiDocument;
